module.exports = __webpack_public_path__ + "static/img/02_02.da63aa6a.jpg";